import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {DefaultResponse, LoginResult} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  API_URL = (environment.production) ?  /*"https://assetlicences.herokuapp.com"*/ "https://database.assetx.it:3443" :
    "http://localhost:8081";

  constructor(
    private http: HttpClient
  ) { }

  getSoftware(name: string) {
    return this.http.get(this.API_URL+'/softwares_storage?name='+name, {responseType: 'arraybuffer'});
  }

  uploadSoftware(formData, name: string): Observable<DefaultResponse> {
    /*return <Observable<LoginResult>>this.http.post<LoginResult>(this.API_URL + '/softwares_storage?name='+name,
      body);*/
    let headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    return this.http.post<DefaultResponse>(this.API_URL + '/softwares_storage?name='+name,
      formData, { headers: headers });
  }
}
